import React, {Component} from 'react';
import {axisBottom, max, scaleBand, scaleLinear, select} from "d3";

class BarChart extends Component {
    constructor(props){
        super(props)
        this.myInputBar = React.createRef()
        this.state = {
            width: 400,
            height: 175,
        }
    }

    /**src/react/src/components/RouteListComponent/RouteRegionComponent.jsx
     * Calculate & Update state of new dimensions
     */
    updateDimensions() {
        if (this.myInputBar.current) {
            this.setState({
                width: this.myInputBar.current.offsetWidth,
            });
        }
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }
    /**
     * Remove event listener
     */
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    drawChart() {
        const width = this.state.width;
        const height = this.state.height;
        const data = this.props.data;

        select("#"+this.props.id + ' svg').remove();
        const svg = select("#"+this.props.id).append("svg")
            .attr("width", width)
            .attr("height", height);

        const margin = ({top: 10, right: 0, bottom: 20, left: 0})
        const minBarHeight =  15;

        const xAxis = g => g
            .attr("transform", `translate(0,${height - margin.bottom})`)
            .call(axisBottom(xScale).tickSizeOuter(0))

        const xScale = scaleBand()
            .domain(data.map(d => d.grade))
            .range([margin.left, width - margin.right])
            .padding(0.1)

        const yScale = scaleLinear()
            .domain([0, Math.max(max(data, d => d.count), 5)]).nice()
            .range([height - margin.bottom - minBarHeight, margin.top])

        svg.append("g")
            .attr("fill", "#132240")
            .selectAll("rect")
            .data(data)
            .join("rect")
            .style("mix-blend-mode", "multiply")
            .attr("x", d => xScale(d.grade))
            .attr("y", d => yScale(d.count))
            .attr("height", d => d.count === 0 ? 0 : minBarHeight + yScale(0) - yScale(d.count))
            .attr("width", xScale.bandwidth());

        svg.selectAll("text")
            .data(data)
            .enter()
            .append("text")
            .text((d) => d.count === 0 ? "" : d.count)
            .attr("text-anchor", "middle")
            //.attr("x", d => x(d.grade))
            .attr("x", d => xScale(d.grade) + ((xScale.bandwidth() - xScale.bandwidth()) / 2) + (xScale.bandwidth()/2))
            .attr("y", d => height - minBarHeight - (yScale(0) - yScale(d.count)))
            .attr("fill", "white");

        // console.log(xScale.bandwidth());

        svg.append("g")
            .call(xAxis);

    }

    render(){
        this.drawChart();

        return  (
            <div ref={this.myInputBar} className="barChartWrapper">
                {this.props.title &&
                <h3>{this.props.title}</h3>
                }
                <div id={this.props.id}/>
            </div>
        )
    }
}

export default BarChart;